import appAxios from "services/axios"

export interface AutomationTrigger {
    typeID: number
    keywords?: string[]
    intention?: string
    exactMatch?: boolean
    mediaID?: string
}

export interface Automation {
    id: number
    name: string
    description: string
    status: string
    createdAt: Date
    updatedAt: Date
    orgID: string
    agentID: string
    nodes: any[]
    edges: any[]
    platform: string
    channelConnection: any
    channelConnectionID: number
    type: string
    automationTriggers: AutomationTrigger[]
    templateID: string
    aiEnabled: boolean
    canvasState: {
        scale: number
        offsetX: number
        offsetY: number
        scaleStep: number
    }
}

export enum AutomationStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
}

export const automationsService = {
    getAutomations: async () => {
        const orgID = localStorage.getItem('orgID')
        if (!orgID) {
            throw new Error('Org ID is not set')
        }
        const { data } = await appAxios.get(`/admin/orgs/${orgID}/automations`)
        return data
    },
    createAutomation: async (automation: Partial<Automation>) => {
        const orgID = localStorage.getItem('orgID')
        if (!orgID) {
            throw new Error('Org ID is not set')
        }
        const result = await appAxios.post(`/admin/orgs/${orgID}/automations`, automation)
        return result.data
    },
    getAutomation: async (automationID: number) => {
        const orgID = localStorage.getItem('orgID')
        if (!orgID) {
            throw new Error('Org ID is not set')
        }
        return appAxios.get(`/admin/orgs/${orgID}/automations/${automationID}`)
    },
    updateAutomation: async (automationID: number, automation: Partial<Automation>) => {
        const orgID = localStorage.getItem('orgID')
        if (!orgID) {
            throw new Error('Org ID is not set')
        }
        const { data } = await appAxios.put(`/admin/orgs/${orgID}/automations/${automationID}`, automation)
        return data
    },
    deleteAutomation: async (automationID: string) => {
        const orgID = localStorage.getItem('orgID')
        if (!orgID) {
            throw new Error('Org ID is not set')
        }
        const { data } = await appAxios.delete(`/admin/orgs/${orgID}/automations/${automationID}`)
        return data
    },
    getNodeStats: async (automationID: number, nodeID: string) => {
        const orgID = localStorage.getItem('orgID')
        if (!orgID) {
            throw new Error('Org ID is not set')
        }
        const { data } = await appAxios.get(`/admin/orgs/${orgID}/automations/${automationID}/node-stats/${nodeID}`)
        return data
    },
    getButtonStats: async (automationID: number, nodeID: string, buttonID: string) => {
        const orgID = localStorage.getItem('orgID')
        if (!orgID) {
            throw new Error('Org ID is not set')
        }
        const { data } = await appAxios.get(`/admin/orgs/${orgID}/automations/${automationID}/button-stats/${buttonID}`)
        return data
    }
}